export default { options: { label: 'Assets' } }
